import { Favorite, FavoriteBorderOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { node_server } from "../../../../../constants";
import { useTheme } from "../../../../../context/themeContext";
import useManageProjects from "../../../../../hooks/useManageProjects";
import useProtectedAuth from "../../../../../hooks/useProtectedAuth";
import Content from "./components/content";
import Header from "./components/header";
import styles from "./style.module.css";

const ProjectDetails = () => {
	useProtectedAuth();

	const { theme } = useTheme();
	const { id } = useParams();
	const [project, setProject] = useState({});
	const [projectAgeRanges, setProjectAgeRanges] = useState([]);
	const [projectUser, setProjectUser] = useState({});
	const [projectRoles, setProjectRoles] = useState([]);
	const [isFavorite, setIsFavorite] = useState(false);
	const { handleFavorite, fetchFavorite } = useManageProjects();

	const addToFavorite = (id) => {
		setIsFavorite(true);
		handleFavorite(id, "add");
	};

	const removeFromFavorite = (id) => {
		setIsFavorite(false);
		handleFavorite(id, "remove");
	};

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			const response = await axios.get(
				`${node_server}/api/projects/details/${id}`,
				{
					withCredentials: true,
				},
			);
			if (response.status !== 200) console.log(response.data);
			if (response.data) setProject(response.data);

			const { data: ageRanges, error: ageRangesError } = await axios.get(
				`${node_server}/api/projects/age-ranges/${id}`,
				{
					withCredentials: true,
				},
			);
			if (ageRangesError) console.log(ageRangesError);
			if (ageRanges) setProjectAgeRanges(ageRanges);
		};

		fetchData();
	}, [id]);

	useEffect(() => {
		const fetchData = async () => {
			if (project.user_id) {
				const response = await axios.get(
					`${node_server}/api/user/${project.user_id}`,
					{
						withCredentials: true,
					},
				);
				const { data, error } = response;
				if (error) console.log(error);

				const {
					data: storedProjectRoles,
					error: storedProjectRolesError,
				} = await axios.get(`${node_server}/api/projects/roles/${id}`, {
					withCredentials: true,
				});
				if (storedProjectRolesError)
					console.log(storedProjectRolesError);

				if (data && storedProjectRoles) {
					setProjectRoles(storedProjectRoles);
					setProjectUser(data);
				}
			}
		};

		const fetchFavouriteResult = async () => {
			const checkIsFavourite = await fetchFavorite(id);
			setIsFavorite(checkIsFavourite);
		};

		fetchData();
		fetchFavouriteResult();
	}, [project]);

	return (
		<Box
			className={styles.projectDetails}
			sx={{
				bgcolor: theme.palette.lightgrey.lightgrey00,
			}}
		>
			<Header
				image={project?.project_cover_image}
				category={project?.category}
			/>
			<Box className={styles.container}>
				<Box className={styles.title}>
					<Typography
						variant="body1"
						sx={{
							fontSize: "18px",
							fontWeight: "700",
							color: theme.palette.darkgrey.darkgrey600,
						}}
					>
						{project?.title}
					</Typography>

					{isFavorite ? (
						<Favorite
							sx={{ fill: theme.palette.primary.light }}
							onClick={() => {
								removeFromFavorite(project.id);
							}}
						/>
					) : (
						<FavoriteBorderOutlined
							sx={{ fill: theme.palette.primary.light }}
							onClick={() => {
								addToFavorite(project.id);
							}}
						/>
					)}
				</Box>
				<Content
					projectUser={projectUser}
					project={project}
					ageRanges={projectAgeRanges}
					projectRoles={projectRoles}
				/>
			</Box>
		</Box>
	);
};

export default ProjectDetails;
